module.exports = __webpack_public_path__ + "static/upload_icon.svg";